import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { EStorageKey } from '@app/app.enums';
import { AuthActions } from '@app/features/auth/auth.actions';
import { KeycloakSessionService } from '@core/services/auth/keycloak-session.service';
import { first, firstValueFrom } from 'rxjs';
import { selectAuth } from '@app/features/auth/auth.selectors';
import { isPublicRoutePath } from '@core/consts/public-access.const';

export const authStateInitializer = async (): Promise<void> => {
  const store = inject(Store);
  const session = inject(KeycloakSessionService);
  let favoriteUrl: string | null = null;
  try {
    const saved: unknown = JSON.parse(
      localStorage.getItem(EStorageKey.MENU_FAVORITE) ?? 'null',
    );
    if (
      typeof saved === 'string' &&
      saved.startsWith('/') &&
      !saved.startsWith('//')
    ) {
      favoriteUrl = saved;
    }
  } catch {
    localStorage.removeItem(EStorageKey.MENU_FAVORITE);
  }
  try {
    await session.initialize();
    if (!isPublicRoutePath(location.pathname)) {
      await firstValueFrom(
        store
          .select(selectAuth)
          .pipe(
            first(
              (state) =>
                !state.authenticated ||
                state.isSecurityAdministrator ||
                state.profileStatus === 'ready' ||
                state.profileStatus === 'failed' ||
                state.profileStatus === 'forbidden',
            ),
          ),
      );
    }
  } catch {
    store.dispatch(
      AuthActions.sessionFailed({ message: 'AUTH.SESSION_ERROR' }),
    );
  }
  store.dispatch(AuthActions.initEnd({ favoriteUrl }));
};
